<mat-form-field [style.width.%]="100" appearance="fill">
  <mat-label translate>DataAggregatedOptions.aggregations</mat-label>
  <mat-select [required]="true" [(ngModel)]="aggregationTypesValue" #ctrl="ngModel"
    (selectionChange)="updateSettings(true, true)">
    <mat-option value="Min">Min</mat-option>
    <mat-option value="Max">Max</mat-option>
    <mat-option value="Avg">Avg</mat-option>
    <mat-option value="Count">Count</mat-option>
    <mat-option value="Sum">Sum</mat-option>
    <mat-option value="Median">Median</mat-option>
    <mat-option value="StdDev">StdDev</mat-option>
    <mat-option value="First">First</mat-option>
    <mat-option value="Last">Last</mat-option>
    <mat-option value="Integral">Integral</mat-option>
  </mat-select>
</mat-form-field>

<mat-form-field [style.width.%]="100" appearance="fill" [ngClass]="{'display-none': disabledInterval}">
  <mat-label translate>DataAggregatedOptions.interval</mat-label>
  <input [required]="requiredInterval" matInput placeholder="ex: 1d, 1h, 1m" [(ngModel)]="intervalValue" #ctrl="ngModel"
    (change)="updateSettings(false)">
</mat-form-field>

<mat-form-field [style.width.%]="100" appearance="fill" [ngClass]="{'display-none': disabledInterpolation}">
  <mat-label translate>DataAggregatedOptions.interpolation</mat-label>
  <mat-select [(ngModel)]="interpolationValue" #ctrl="ngModel" (selectionChange)="updateSettings(false)">
    <mat-option value="Skip">Skip</mat-option>
    <mat-option value="Previous">Previous</mat-option>
    <mat-option value="Linear">Linear</mat-option>
  </mat-select>
</mat-form-field>

<mat-form-field [style.width.%]="100" appearance="fill" [ngClass]="{'display-none': disabledTimeUnit}">
  <mat-label translate>DataAggregatedOptions.integralTimeUnit</mat-label>
  <input [required]="requiredIntegralTimeUnit" matInput placeholder="ex: 1d, 1h, 1m" [(ngModel)]="integralTimeUnitValue"
    #ctrl="ngModel" (change)="updateSettings(false)">
</mat-form-field>